<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('serviceUtilisateur.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="columns">
        <tiers-autocomplete
          v-model="service"
          :societeActiveId="societeActiveId"
          :type="constantes.TIERS_TYPE_FOURNISSEUR"
          :sousTypes="[constantes.TIERS_SOUS_TYPE_SERVICE]"
          :filteredItemFunc="queryService"
          expanded
          open-on-focus
          class="column">
          <template slot-scope="{ option }">
            <p>
              <span v-if="option.code">{{ option.code }} </span>
              <span>{{ option.nomCommercial }}</span>
            </p>
            <p class="is-size-8 is-italic">
              <span v-if="option.compteComptable">{{ option.compteComptable }} </span>
              <span>{{ option.adressePostaleLibelle }}</span>
            </p>
          </template>
        </tiers-autocomplete>
      </div>
      <footer class="is-flex">
        <button class="button boutonAction" @click="$parent.close()">
          {{ $t('general.button.cancel')}}
        </button>
        <button
          class="button boutonAction is-addOrEdit"
          @click="save()"
          :disabled="!service">
          {{ $t('general.button.sauvegarder') }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TiersAutocomplete from '@/components/general/autocomplete/tiersAutocomplete';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_SERVICE,
} from '@/configuration/tiers/tiersConf';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'PAddService',
  props: {
    utilisateur: {
      type: Object,
      required: true,
    },
  },
  components: {
    TiersAutocomplete,
  },
  data() {
    return {
      service: null,
      constantes: {
        TIERS_TYPE_FOURNISSEUR,
        TIERS_SOUS_TYPE_SERVICE,
      },
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    save() {
      this.utilisateur.services.push(this.service);
      this.$emit('updateServices');
      this.$parent.close();
    },
    queryService(item) {
      return !this.utilisateur.services
        .some(el => el.id === item.id);
    },
  },
};
</script>
